export const CONTRACTOR_CONFIRM_DATA = 'CONTRACTOR_CONFIRM_DATA';
export const SEND_DATA = 'SEND_DATA';
export const ATTENTED_DOCS = 'ATTENTED_DOCS';
